import React from 'react';

// [진행 중 로딩] 종류별 문구
const PROGRESS_TEXT = {
  mint: { title: '상품 등록 중입니다', desc: '약 30초~1분 소요 · 창을 닫지 마세요' },
  purchase: { title: '결제 중입니다', desc: '약 20초 소요 · 창을 닫지 마세요' },
  reward: { title: '경품 지급 중입니다', desc: '약 20초 소요 · 창을 닫지 마세요' },
};

/**
 * [진행 중 로딩] 화면 가운데 로딩 오버레이 (뒤 화면 클릭 차단, 닫기 버튼 없음)
 * 2분 지연 시 안내 문구 + [닫기]
 */
const ProgressOverlay = ({ progress, isDelayed, onClose }) => {
  if (!progress) return null;

  const text = PROGRESS_TEXT[progress.kind] || PROGRESS_TEXT.mint;

  return (
    // z-index는 Swal 컨테이너(1060)보다 낮게 — 결과·오류 팝업이 항상 위에 보이도록
    <div className="fixed inset-0 z-[1050] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-lg px-10 py-8 mx-4 max-w-sm text-center">
        {isDelayed ? (
          <>
            <p className="text-gray-800 font-medium mb-6">처리가 지연되고 있습니다. 담당자에게 문의해 주세요</p>
            <button
              type="button"
              onClick={onClose}
              className="btn btn-primary"
            >
              닫기
            </button>
          </>
        ) : (
          <>
            <div className="mb-4">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
            <p className="text-gray-800 font-semibold mb-2">{text.title}</p>
            <p className="text-gray-500 text-sm">{text.desc}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ProgressOverlay;
